import React from 'react'

export default function ErrorPage() {
  return (
    <div>Ooops something went wrong while fetching the information you requested. Here is an alternative:</div>
  )
}
